import classNames from 'classnames'
import React, { FC } from 'react'
import * as css from './Cell.css'

export interface CellProps {
  className?: string
}

const Cell: FC<CellProps> = ({ className, children }) => {
  return <div className={classNames(css['cell'], className)}>{children}</div>
}

export default Cell
